import React from "react";
import { motion } from "framer-motion";
import {
  FaDiscord,
  FaTwitter,
  FaYoutube,
  FaTwitch,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="relative z-20 bg-[#1A181C] text-gray-300 pt-12 pb-6"
    >
      {/* Top Gradient Border */}
      <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500" />

      <div className="w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 xl:gap-10 text-center lg:text-start">
          {/* Logo & Tagline */}
          <div>
            <h2
              onClick={() => {
                navigate("/");
              }}
              className="text-3xl font-bold text-white mb-3"
            >
              <img
                src={require("../Asset/images/logo556.png")}
                alt="logo"
                className="mx-auto lg:mx-0 h-10"
              />
            </h2>
            <h2 className="text-lg font-bold mb-1 gradient-text">Play Beyond Limits</h2>
            <p className="text-sm text-gray-400 leading-relaxed">
              Level up your gaming experience with the best deals and latest
              releases.
            </p>
            {/* <div className="flex justify-center lg:justify-start space-x-4 mt-4">
              {[FaDiscord, FaTwitter, FaYoutube, FaTwitch].map((Icon, idx) => (
                <Link
                  to=""
                  key={idx}
                  className="text-gray-400 hover:text-white hover:scale-110 transition-transform duration-200 cursor-none"
                >
                  <Icon size={22} />
                </Link>
              ))}
            </div> */}
          </div>

          <div className="flex justify-evenly">
            {/* Quick Links */}
            <div className="w-full">
              <h3 className="text-white text-lg font-semibold mb-4">
                Quick Links
              </h3>
              <ul className="space-y-2 text-sm">
                {[
                  { name: "Home", path: "/" },
                  { name: "Games", path: "/games" },
                  { name: "Contact", path: "/contact" },
                ].map((link) => (
                  <li key={link.name}>
                    <NavLink
                      to={link.path}
                      end={link.path === "/"}
                      className={({ isActive }) =>
                        `transition hover:text-white cursor-none hover:pl-1 duration-200  ${isActive ? "text-purple-400" : "text-gray-400"
                        }`
                      }
                    >
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div className="w-full">
              <h3 className="text-white text-lg font-semibold mb-4">Support</h3>
              <ul className="space-y-2 text-sm">
                {[
                  { name: "FAQs", path: "/Faq" },
                  // { name: "Help Center", path: "" },
                  { name: "Privacy Policy", path: "/privacyPolicy" },
                  { name: "Terms of condition", path: "/termsCondition" },
                ].map((link) => (
                  <li key={link.name}>
                    {link.path ? (
                      <NavLink
                        to={link.path}
                        end
                        className={({ isActive }) =>
                          `transition-colors duration-200 ease-in-out hover:text-white cursor-none hover:pl-1 ${isActive ? "text-purple-400" : "text-gray-400"}`
                        }
                      >
                        {link.name}
                      </NavLink>
                    ) : (
                      <span className="transition hover:text-white hover:pl-1 duration-200 block text-gray-400 cursor-none">
                        {link.name}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Newsletter & Socials - Hidden on small screens, shown on large screens */}
          <div className="">
            <h3 className="text-white text-lg font-semibold mb-4">
              Contact Info
            </h3>
            <ul className="space-y-4 text-sm text-gray-400 mb-6">
              <li className="flex items-center md:justify-start justify-center space-x-3 cursor-none">
                <FaEnvelope className="text-purple-500 text-lg" />
                <a
                  href="mailto:info@yoyogames.ca"
                  className="hover:text-purple-400 transition-colors cursor-none"
                >
                  info@yoyogames.ca
                </a>
              </li>

              <li className="flex items-center md:justify-start justify-center space-x-3 cursor-none">
                <FaPhoneAlt className="text-purple-500 text-lg" />
                <div className="flex items-center space-x-2">
                  <a
                    href="tel:1800-9797-6361"
                    className="hover:text-purple-400 transition-colors cursor-none"
                  >
                    1800-9797-6361
                  </a>
                  <span className="text-gray-600 font-bold">|</span>
                  <a
                    href="tel:+15198817124"
                    className="hover:text-purple-400 transition-colors cursor-none"
                  >
                    +0261 3102715
                  </a>
                </div>
              </li>


              <li className="flex items-start md:justify-start justify-center space-x-3 cursor-none">
                <FaMapMarkerAlt className="text-purple-500 text-lg mt-1" />
                <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/maps/place/Shyam+Mandir+Rd,+Hukmchand+Nagar,+Althan,+Surat,+Gujarat+395007/@21.1460831,72.800298,1060m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3be05203d87284f1:0xc550f071f2d34a38!8m2!3d21.1460831!4d72.800298!16s%2Fg%2F11f2v569v2?entry=ttu&g_ep=EgoyMDI2MDQwMS4wIKXMDSoASAFQAw%3D%3D" className="text-center md:text-left cursor-none">
                  402–405 Astha Shoppers NearBy
                  BhagvanMahavir Collage, Vesu, Surat –395007
                  (Branch)
                </a>
              </li>
            </ul>
            {/* <div className="flex mb-4">
              <input
                type="email"
                placeholder="Your email"
                className="px-3 py-2 w-full rounded-l-lg bg-[#0f0f11] border border-gray-700 focus:outline-none text-sm"
                required
              />
              <button type="submit" className="px-4 py-2 bg-purple-600 text-white text-sm rounded-r-lg hover:bg-purple-700 transition">
                Join
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {/* Bottom Copyright */}
      <div className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-500">
        &copy; {new Date().getFullYear()} YOYO GAMES. All rights reserved by VS Infotech.
      </div>
    </motion.footer>
  );
};

export default Footer;
